import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Typography, Paper, makeStyles, CustomPieChart, WorkIcon } from '../../../../..';
var useStyles = makeStyles(function (theme) {
  return {
    paper: {
      width: '100%',
      padding: '30px',
      'text-align': 'center'
    },
    dflex: {
      display: 'flex',
      'align-items': 'center',
      padding: '5px 0px',
      'justify-content': 'space-evenly'
    },
    mr10: {
      'margin-right': '10px'
    },
    fcolumn: {
      'flex-direction': 'column'
    }
  };
});

var ProjectCharts = function ProjectCharts(_ref) {
  var projects = _ref.projects,
      translation = _ref.translation,
      locale = _ref.locale,
      props = _objectWithoutProperties(_ref, ["projects", "translation", "locale"]);

  // console.log('projects en ProjectCharts', projects)
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 2,
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Projects "), /*#__PURE__*/React.createElement("section", {
    className: classes.dflex
  }, /*#__PURE__*/React.createElement("article", {
    className: [classes.dflex, classes.mr10].join(' ')
  }, /*#__PURE__*/React.createElement(WorkIcon, {
    className: classes.mr10
  }), " ", /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, projects && projects.length))), projects && projects.length && /*#__PURE__*/React.createElement("section", {
    className: [classes.dflex, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(CustomPieChart, {
    groupedBy: "infoProject.type",
    acc: "infoProject.budget",
    height: 250,
    width: '50%',
    data: projects,
    locale: locale,
    translation: translation ? translation : {
      event: 'Events',
      campus: 'Camps',
      academy: 'Academies'
    }
  }), /*#__PURE__*/React.createElement(CustomPieChart, {
    groupedBy: "statusExecution",
    acc: "infoProject.budget",
    height: 250,
    data: projects,
    locale: locale,
    translation: translation ? translation.statusExecution : {
      plan: 'Plan',
      docheck: 'Do & Check',
      close: 'Close'
    }
  })));
};

export { ProjectCharts };